import { useEffect } from 'react';
import { queryClient } from '~/client/queryClient';
import { User, UserQueryKeys } from '~/types/user';

const CURRENT_USER_ID_KEY = 'sibill-current-user-id';

export const notifyAuthChanged = (userId: User['id'] | null) => {
  try {
    if (userId) {
      localStorage.setItem(CURRENT_USER_ID_KEY, userId);
    } else {
      localStorage.removeItem(CURRENT_USER_ID_KEY);
    }
  } catch {
    // localStorage may be unavailable (private mode, quota exceeded)
  }
};

export const useAuthSync = () => {
  useEffect(() => {
    const handler = () => {
      if (document.visibilityState !== 'visible') return;
      const cached = queryClient.getQueryData<User>(UserQueryKeys.currentUser);
      if (cached && cached.id !== localStorage.getItem(CURRENT_USER_ID_KEY)) {
        window.location.reload();
      }
    };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);
};
